// material-ui
import {} from '@mui/material'

// assets

import PlaywatchKidsComponent from 'components/PlaywatchKidsComponent'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid

  function grid(): any {
    return <PlaywatchKidsComponent />
  }

  let output_grid = grid()

  return output_grid
}
